export const contactServiceOptions = [
  { value: 'Recurring Home Cleaning', slug: 'recurring-cleaning' },
  { value: 'Deep Cleaning', slug: 'deep-cleaning' },
  { value: 'Move-In / Move-Out Cleaning', slug: 'move-in-out-cleaning' },
  { value: 'Not Sure Yet', slug: 'not-sure' },
];

export const propertyTypes = ['Apartment', 'House', 'Townhouse', 'Condo', 'Other'];

export const infoCards = [
  { icon: 'ri-home-4-line', title: 'Tell us about your home', text: 'Property type, number of rooms and any areas that need extra attention.' },
  { icon: 'ri-sparkling-2-line', title: 'Choose a service', text: 'Pick the option that feels closest — or select “Not Sure Yet” and we can help.' },
  { icon: 'ri-chat-smile-2-line', title: 'We follow up', text: 'We review your request and get back to you to discuss the next steps.' },
];

export const contactFaqs = [
  { q: 'What information should I include in my request?', a: 'The type of service you are interested in, your property type, an approximate size and any specific areas or preferences are all helpful.' },
  { q: 'I am not sure which service I need. What should I choose?', a: 'Select “Not Sure Yet” and describe your home in the details field. We can help you explore which option might fit best.' },
  { q: 'Does requesting a quote commit me to anything?', a: 'No. A quote request simply starts the conversation so we can learn about your space and discuss options.' },
  { q: 'Can I request a specific date?', a: 'You can add a preferred date in the form. Availability is discussed and confirmed when we follow up.' },
];